import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from './component/admin-layout/layout.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from './shared/shared.module';
import {LoaderService} from './service/loader.service';
import {AppConfigService} from '../app-config.service';
import {AuthModule} from './component/auth/auth.module';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {ErrorInterceptor} from './shared/interceptor/error.interceptor';
import {AuthGuard} from './shared/guards/guards.class';
import {PageDefaultModule} from './shared/component/page-default/page-default.module';
import {en_US, NZ_DATE_LOCALE, NZ_I18N, vi_VN} from 'ng-zorro-antd/i18n';
import {appInitializer} from './shared/helpers/app.initializer';
import {AccountService} from './service/account-service';
import {ControlModule} from './component/admin-layout/controls/control.module';
import {NgbDateCustomParserFormatter} from './shared/utils/date-formatter';
import {NgbDateParserFormatter, NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateCustomDateAdapter} from './shared/utils/date-adapter';
import {environment} from '../environments/environment';
import {MessagingService} from './service/messaging.service';
import {AsyncPipe} from '@angular/common';
import {vi, enUS} from 'date-fns/locale';
import {NZ_CONFIG} from 'ng-zorro-antd/core/config';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { KetquaComponent } from './component/public/ketqua/ketqua.component';

export function configServiceFactory(config: AppConfigService) {
  return () => config.load();
}

@NgModule({
  declarations: [AppComponent, KetquaComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedModule,
    AuthModule,
    PageDefaultModule,
    EffectsModule.forRoot([]),
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument(),
    ControlModule,
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
    // InputMaskModule.forRoot({ inputSelector: 'input', isAsync: true })
  ],
  exports: [],
  providers: [
    AsyncPipe,
    // { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AccountService] },
    LoaderService,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [AppConfigService],
      multi: true,
    },
    {provide: NZ_I18N, useValue: vi_VN},
    {provide: NZ_DATE_LOCALE, useValue: vi},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    AuthGuard,
    {provide: NgbDateAdapter, useClass: NgbDateCustomDateAdapter}, //le.huathi - custom date adapter
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}, //le.huathi - custom date formatter
    {
      provide: NZ_CONFIG,
      useValue: {
        button: {
          nzSize: 'small',
        },
      },
    },
    MessagingService
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor() {
    this.overrideNewDate();
  }

  overrideNewDate() {
    Date.prototype.toJSON = function(key) {
      if (!this) {
        return null;
      }
      let saveDate = new Date(
        this.getTime() - this.getTimezoneOffset() * 60000
      );
      //return what you want
      let dateISOString = saveDate.toISOString();
      // remove character "Z" in date
      return dateISOString.slice(0, dateISOString.length - 1);
    };
  }
}
